import React from "react";
import * as Yup from "yup";
import moment from "moment";


const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
const phoneRegex = /^\d{10}$/; 
const usernameRegex = /^[^\s]*$/;

const editUser = {
  // userName: Yup.string().required("Required"),
  userName: Yup.string()
    .matches(usernameRegex, "User Name should not have Spaces")
    .required("Required"),
  // password: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  joinDate: Yup.date().required("Required"),
  endDate: Yup.date().required("Required"),
  acctType: Yup.string().required("Required"),
  stsCd: Yup.string().required("Required"),
  // phone: Yup.string().required("Required"),
  phone: Yup.string()
    .matches(phoneRegex, "Invalid phone number")
    .required("Required"),
  email: Yup.string()
    .matches(emailRegex, "Invalid email format")
    .required("Required"),
  // email: Yup.string().email("Invalid email").required("Required"),
  // address: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  addressLine1: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  country: Yup.string().required("Required"),
  zip: Yup.string().required("Required"),
  // reportsTo: Yup.string().required("Required"),
};

export const getValuesFromLocalstorage = (storageKey) => {
  const userDetails =
    storageKey === "accessToken"
      ? localStorage.getItem(storageKey)
      : JSON.parse(localStorage.getItem(storageKey));

  return userDetails || null;
};

export const SignupSchema = Yup.object().shape({
  userName: Yup.string().required("Username is Required"),
  // password: Yup.string("Enter your password")
  //   .min(7, "Password should be 7 characters length")
  //   .required("Password is Required")
  //   .matches(passwordRegex, "Password don't matches criteria "),
});

export const ForgotPasswordSchema = Yup.object().shape({
  // email: Yup.string().email("Email is Required"),
  email: Yup.string()
    .required("Email is required")
    .matches(emailRegex, "This is not a valid email"),
});

export const ResetPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .matches(passwordRegex, "Password criteria not met"),

  confirmPassword: Yup.string()
    .min(8, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    // .matches(passwordRegex,"Password don't matches")
    .oneOf([Yup.ref("newPassword"), null], "passwords must match"),
});

export const UpdatePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string("old password is required"),
  newPassword: Yup.string()
    .min(6, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .matches(passwordRegex, "Password must be at least 8 characters, contain one uppercase letter, one lowercase letter, one number, and one special character (@, $, !, %, *, ?, &, #)"),
  confirmPassword: Yup.string()
    .min(6, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .oneOf([Yup.ref("newPassword"), null], "passwords must match"),
});
export const EditUserSchema = Yup.object(editUser);
export const AddUserSchema = Yup.object({
  ...editUser,
  // password: Yup.string().required("Required"),
  password: Yup.string()
    .matches(
      passwordRegex,
      "Password must be at least 8 characters, contain one uppercase letter, one lowercase letter, one number, and one special character (@, $, !, %, *, ?, &, #)"
    )
    .required("Required"),
});

export const projectValidationSchema = Yup.object({
  userId: Yup.number().required("User ID is required"),
  // username: Yup.string().required("Username is required"),
  projectName: Yup.string().required("Project Name is required"),
  clientId: Yup.string().required("Client is required"),
  startDate: Yup.date().required("Start Date is required"),
  // endDate: Yup.date()
  //   .required("End Date is required")
  //   .min(Yup.ref("startDate"), "End date cannot be before start date"),
  budget: Yup.number().required("Budget is required"),
  netPay: Yup.number().required("Net Pay is required"),
});

export const clientValidationSchema = Yup.object({
  name: Yup.string().required("Client Name is required"),
  addressLine1: Yup.string().required("Address is required"),
  addressLine2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("ZIP is required"),
});

const editClient = {
  name: Yup.string().required("Client Name is required"),
  addressLine1: Yup.string().required("Address is required"),
  addressLine2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("ZIP is required"),
};

export const EditClientSchema = Yup.object(editClient);
export const AddClientSchema = Yup.object(editClient);

export const employeeValidationSchema = Yup.object({
  userName: Yup.string().required("User Name required"),
  password: Yup.string().required("Password required"),
  firstName: Yup.string().required("First Name required"),
  lastName: Yup.string().required("Last Name required"),
  email: Yup.string().required("Email is required"),
  Gender: Yup.string().required("Gender is required"),
  joinDate: Yup.date().required("Join Date is required"),
  endDate: Yup.date().required("End Date is required"),
  phone: Yup.string().required("Phone Number is required"),
  accountType: Yup.string().required("Account type is required"),
  status: Yup.string().required("status is required"),
  reportsTo: Yup.string().required("Reporting to is required"),
  address1: Yup.string().required("Address is required"),
  address2: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("Zip required"),
});

export const editvalidationSchema = Yup.object({
  userName: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  joinDate: Yup.date().required("Required"),
  endDate: Yup.date(),
  accountType: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  address: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  country: Yup.string().required("Required"),
  zip: Yup.string().required("Required"),
  reportsTo: Yup.string().required("Required"),
});

// export const documentValidationSchema = Yup.object({
//   documentType: Yup.string()
//     // .oneOf(["PASSPORT","DRIVER_LICENSE","VISA","EAD"], "Invalid document type")
//     .required("Document type is required"), 
//     issueDate: Yup.date().required("Required"),
//     expiryDate: Yup.date()
//     .required("Required"),
//     file: Yup.mixed().required('File is required'),
// });



export const documentValidationSchema = Yup.object({
  documentType: Yup.string().required("Document type is required"),

  others: Yup.string().when("documentType", {
    is: "OTHER",
    then: (schema) => schema.required("Please enter document type"),
    otherwise: (schema) => schema.notRequired(),
  }),

  issueDate: Yup.date().when("documentType", {
    is: (val) => val !== "OTHER",
    then: (schema) => schema.required("Issue Date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  expiryDate: Yup.date()
    .when("documentType", {
      is: (val) => val !== "OTHER",
      then: (schema) =>
        schema
          .required("Expiry Date is required")
          .min(moment().startOf("day"), "Expiry date cannot be in the past"),
      otherwise: (schema) => schema.notRequired(),
    }),

  file: Yup.mixed().required("File is required"),
});


export const timeSheetValidationSchema = Yup.object().shape({
  projectId: Yup.string()
    .required('Project is required'),
  work_location: Yup.string()
    .required('Work location is required'),
  startDate: Yup.date()
    .required('Start date is required'),
    // .max(new Date(), 'Start date cannot be in the future'),
  endDate: Yup.date()
    .required('End date is required')
    .min(Yup.ref('startDate'), 'End date must be after start date'),
    // .max(new Date(), 'End date cannot be in the future'),
  total_hours: Yup.number()
    .required('Total hours is required') 
});

export const statusValidationSchema = Yup.object({
  userId: Yup.object().required("Employee selection is required"),
  userStatus: Yup.string().required("Status is required"),
  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date()
    .required("End date is required")
    .min(Yup.ref("startDate"), "End date cannot be before start date"),
  statusCode: Yup.string().required("Status code is required"),
  // files: Yup.array()
  //   .min(1, "You must upload at least one file")
  //   .required("Files are required"),
});

export const ContactInfoSchema = Yup.object().shape({
  phone: Yup.string()
    .required('Phone number is required')
    .matches(/^\d{10}$/, 'Phone number must be  10 digits')
    .nullable()
    .transform((value) => (value === '' ? null : value)),
});

export const AddressSchema = Yup.object().shape({
  addressLine1: Yup.string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  city: Yup.string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  state: Yup.string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  country: Yup.string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  zip: Yup.string()
    .nullable()
    .transform((value) => (value === '' ? null : value))
    .test('zip-format', 'Invalid ZIP/Postal code format', function(value) {
      if (!value) return true; // Allow empty/null values
      
      const country = this.parent.country;
      
      if (country === 'USA') {
        // US ZIP code format (5 digits)
        return /^\d{5}$/.test(value);
      } else if (country === 'IN') {
        // Indian PIN code format (6 digits)
        return /^\d{6}$/.test(value);
      }
      
      // For other countries, accept any non-empty value
      return value.length > 0;
    }),
}); 




